import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"
import {
    contractingServices,
    annualConstructionPercentage,
    estimatedPercentageOfCompanyTotalRevenue
} from "../constant/utils"

export const getStates = createAsyncThunk("get-states", async () => {
    const response = await api.getStates()
    return response
})

export const getTypeOfEntity = createAsyncThunk("get-type-of-entities", async () => {
    const response = await api.getTypeOfEntity()
    return response
})

export const getRoles = createAsyncThunk("get-roles", async () => {
    const response = await api.getRoles()
    return response
})

export const getNamedInsuredRelationships = createAsyncThunk("get-named-insured-relationships", async () => {
    const response = await api.getNamedInsuredRelationships()
    return response
})

export const getRetentionAmount = createAsyncThunk("get-retention-amount", async () => {
    const response = await api.getRetentionAmount()
    return response
})

export const getContractorsPollutionCoverage = createAsyncThunk("get-contractors-pollution-coverage", async () => {
    const response = await api.getContractorsPollutionCoverage()
    return response
})

export const getProfessionalLiabilityCoverage = createAsyncThunk("get-professional-liability-coverage", async () => {
    const response = await api.getProfessionalLiabilityCoverage()
    return response
})

export const getNonOwnedDisposalSiteCoverages = createAsyncThunk("get-non-owned-disposal-site-coverage", async () => {
    const response = await api.getNonOwnedDisposalSiteCoverages()
    return response
})

export const getMoldCoverages = createAsyncThunk("get-mold-coverages", async () => {
    const response = await api.getMoldCoverages()
    return response
})

export const getLimits = createAsyncThunk("get-limits", async () => {
    const response = await api.getLimits()
    return response
})

export const getApplicationStatus = createAsyncThunk("get-application-status", async () => {
    const response = await api.getApplicationStatus()
    return response
})

export const getEndorsementTypes = createAsyncThunk("get-endorsement-types", async () => {
    const response = await api.getEndorsementTypes()
    return response
})

export const getLogicalOperatorTypes = createAsyncThunk("get-logical-operator-types", async () => {
    const response = await api.getLogicalOperatorTypes()
    return response
})

export const getEndorsementAppliesToList = createAsyncThunk("get-endorsement-applies-to-list", async () => {
    const response = await api.getEndorsementAppliesToList()
    return response
})

export const getContractingServices = createAsyncThunk("get-contracting-services", async () => {
    return contractingServices
})

export const getAnnualConstructionPercentage = createAsyncThunk("get-annual-construction-percentage", async () => {
    return annualConstructionPercentage
})

export const getEstimatedPercentageOfCompanyTotalRevenues = createAsyncThunk(
    "get-estimated-percentage-of-company-total-revenues",
    async () => {
        return estimatedPercentageOfCompanyTotalRevenue
    }
)

const enumSlice = createSlice({
    name: "settings",
    initialState: {
        states: [],
        typeOfEntities: [],
        roles: [],
        namedInsuredRelationships: [],
        services: [],
        moldCoverages: [],
        annualConstructionPercentage: [],
        retentionAmounts: [],
        contractorsPollutionCoverage: [],
        professionalLiabilityCoverages: [],
        nonOwnedDisposalSiteCoverages: [],
        estimatedPercentageOfCompanyTotalRevenues: [],
        limits: [],
        applicationStatus: [],
        endorsementTypes: [],
        logicalOperatorTypes: [],
        endorsementAppliesToList: [],
        settings: {},
        fetchStatus: "",
        action: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStates.fulfilled, (state, action) => {
                state.states = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getStates"
            })
            .addCase(getStates.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getStates"
            })
            .addCase(getStates.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getStates"
            })
            .addCase(getEndorsementTypes.fulfilled, (state, action) => {
                state.endorsementTypes = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getEndorsementTypes"
            })
            .addCase(getEndorsementTypes.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getEndorsementTypes"
            })
            .addCase(getEndorsementTypes.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getEndorsementTypes"
            })
            .addCase(getLogicalOperatorTypes.fulfilled, (state, action) => {
                state.logicalOperatorTypes = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getLogicalOperatorTypes"
            })
            .addCase(getLogicalOperatorTypes.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getLogicalOperatorTypes"
            })
            .addCase(getLogicalOperatorTypes.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getLogicalOperatorTypes"
            })
            .addCase(getEndorsementAppliesToList.fulfilled, (state, action) => {
                state.endorsementAppliesToList = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getEndorsementAppliesToList"
            })
            .addCase(getEndorsementAppliesToList.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getEndorsementAppliesToList"
            })
            .addCase(getEndorsementAppliesToList.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getEndorsementAppliesToList"
            })
            .addCase(getTypeOfEntity.fulfilled, (state, action) => {
                state.typeOfEntities = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getTypeOfEntity"
            })
            .addCase(getTypeOfEntity.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getTypeOfEntity"
            })
            .addCase(getTypeOfEntity.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getTypeOfEntity"
            })
            .addCase(getLimits.fulfilled, (state, action) => {
                state.limits = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getLimits"
            })
            .addCase(getLimits.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getLimits"
            })
            .addCase(getLimits.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getLimits"
            })
            .addCase(getApplicationStatus.fulfilled, (state, action) => {
                state.applicationStatus = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getApplicationStatus"
            })
            .addCase(getApplicationStatus.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getApplicationStatus"
            })
            .addCase(getApplicationStatus.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getApplicationStatus"
            })
            .addCase(getMoldCoverages.fulfilled, (state, action) => {
                state.moldCoverages = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getMoldCoverages"
            })
            .addCase(getMoldCoverages.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getMoldCoverages"
            })
            .addCase(getMoldCoverages.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getMoldCoverages"
            })
            .addCase(getRoles.fulfilled, (state, action) => {
                state.roles = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getRoles"
            })
            .addCase(getRoles.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getRoles"
            })
            .addCase(getRoles.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getRoles"
            })
            .addCase(getNamedInsuredRelationships.fulfilled, (state, action) => {
                state.namedInsuredRelationships = action.payload?.items?.filter((item) => item.value != "None") || []
                state.fetchStatus = "success"
                state.action = "getNamedInsuredRelationships"
            })
            .addCase(getNamedInsuredRelationships.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getNamedInsuredRelationships"
            })
            .addCase(getNamedInsuredRelationships.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getNamedInsuredRelationships"
            })
            .addCase(getRetentionAmount.fulfilled, (state, action) => {
                state.retentionAmounts = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getRetentionAmount"
            })
            .addCase(getRetentionAmount.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getRetentionAmount"
            })
            .addCase(getRetentionAmount.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getRetentionAmount"
            })
            .addCase(getProfessionalLiabilityCoverage.fulfilled, (state, action) => {
                state.professionalLiabilityCoverages =
                    action.payload?.items?.filter((item) => item.value != "None") || []
                state.fetchStatus = "success"
                state.action = "getProfessionalLiabilityCoverage"
            })
            .addCase(getProfessionalLiabilityCoverage.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getProfessionalLiabilityCoverage"
            })
            .addCase(getProfessionalLiabilityCoverage.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getProfessionalLiabilityCoverage"
            })
            .addCase(getNonOwnedDisposalSiteCoverages.fulfilled, (state, action) => {
                state.nonOwnedDisposalSiteCoverages =
                    action.payload?.items?.filter((item) => item.value != "None") || []
                state.fetchStatus = "success"
                state.action = "getNonOwnedDisposalSiteCoverages"
            })
            .addCase(getNonOwnedDisposalSiteCoverages.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getNonOwnedDisposalSiteCoverages"
            })
            .addCase(getNonOwnedDisposalSiteCoverages.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getNonOwnedDisposalSiteCoverages"
            })
            .addCase(getContractorsPollutionCoverage.fulfilled, (state, action) => {
                state.contractorsPollutionCoverage = action.payload?.items || []
                state.fetchStatus = "success"
                state.action = "getContractorsPollutionCoverage"
            })
            .addCase(getContractorsPollutionCoverage.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getContractorsPollutionCoverage"
            })
            .addCase(getContractorsPollutionCoverage.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getContractorsPollutionCoverage"
            })

            .addCase(getContractingServices.fulfilled, (state, action) => {
                state.services = action.payload
                state.fetchStatus = "success"
                state.action = "getContractingServices"
            })
            .addCase(getContractingServices.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getContractingServices"
            })
            .addCase(getContractingServices.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getContractingServices"
            })

            .addCase(getAnnualConstructionPercentage.fulfilled, (state, action) => {
                state.annualConstructionPercentage = action.payload
                state.fetchStatus = "success"
                state.action = "getAnnualConstructionPercentage"
            })
            .addCase(getAnnualConstructionPercentage.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getAnnualConstructionPercentage"
            })
            .addCase(getAnnualConstructionPercentage.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getAnnualConstructionPercentage"
            })

            .addCase(getEstimatedPercentageOfCompanyTotalRevenues.fulfilled, (state, action) => {
                state.estimatedPercentageOfCompanyTotalRevenues = action.payload
                state.fetchStatus = "success"
                state.action = "getEstimatedPercentageOfCompanyTotalRevenues"
            })
            .addCase(getEstimatedPercentageOfCompanyTotalRevenues.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getEstimatedPercentageOfCompanyTotalRevenues"
            })
            .addCase(getEstimatedPercentageOfCompanyTotalRevenues.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getEstimatedPercentageOfCompanyTotalRevenues"
            })
    }
})

export default enumSlice

export const { name, actions, reducers } = enumSlice
